import React, { useState } from "react";
import { X } from "lucide-react";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";
const inputCls = "w-full bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50 transition-colors";

export default function CorrectionModal({ visible, onClose }) {
  const [desc,       setDesc]       = useState("");
  const [month,      setMonth]      = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted,  setSubmitted]  = useState(false);
  const [error,      setError]      = useState(null);

  if (!visible) return null;

  const submit = async () => {
    if (!desc.trim()) { setError("Please describe the issue."); return; }
    setSubmitting(true);
    setError(null);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE}/api/payroll/correction`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
        body: JSON.stringify({ month, message: desc }),
      });
      if (!res.ok) {
        const detail = await res.json().catch(() => null);
        throw new Error(detail?.detail || `Request failed (HTTP ${res.status})`);
      }
      setSubmitted(true);
      setTimeout(() => { setSubmitted(false); setDesc(""); setMonth(""); onClose(); }, 1500);
    } catch (e) {
      setError(e.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[9999] p-4">
      <div className="w-full max-w-md rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_40px_#00ff9022]">
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/5">
          <h2 className="text-sm font-semibold text-white">Request Payslip Correction</h2>
          <button onClick={onClose} className="w-8 h-8 rounded-lg border border-white/10 bg-white/5 flex items-center justify-center text-white/40 hover:text-white transition-colors"><X size={14} /></button>
        </div>

        {submitted ? (
          <div className="px-6 py-10 text-center">
            <p className="text-3xl mb-3">✓</p>
            <p className="text-[#00ff90] font-medium">Request submitted</p>
            <p className="text-white/40 text-sm mt-1">HR will review your request.</p>
          </div>
        ) : (
          <div className="px-6 py-5 space-y-4">
            <div>
              <label className="text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5">Payslip Month</label>
              <input type="month" value={month} onChange={e => setMonth(e.target.value)} required className={inputCls} />
            </div>
            <div>
              <label className="text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5">Describe the Issue</label>
              <textarea value={desc} onChange={e => setDesc(e.target.value)} rows={4}
                placeholder="e.g. Incorrect overtime amount for March…"
                className={`${inputCls} resize-none placeholder-white/20`} />
            </div>
            {error && <p className="text-red-400 text-xs">⚠ {error}</p>}
            <div className="flex justify-end gap-2 pt-1">
              <button onClick={onClose} className="text-xs px-4 py-2 rounded-lg border border-white/10 text-white/40 hover:text-white transition-colors">Cancel</button>
              <button onClick={submit} disabled={submitting}
                className="text-xs px-5 py-2 rounded-lg bg-[#00ff90]/15 text-[#00ff90] border border-[#00ff90]/30 hover:bg-[#00ff90]/25 disabled:opacity-40 transition-colors font-medium">
                {submitting ? "Submitting…" : "Submit Request"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}